import type { ForwardedRef, MouseEventHandler, ReactElement, ReactNode } from "react";
import { forwardRef } from "react";

import type { TextProps } from "@similarweb/ui-components/foundations";

import { StyledTruncatedText, StyledTruncatedTextLabel } from "./styles";

interface ITruncatedTooltipProps extends Omit<TextProps, "children"> {
    lineClamp?: number;
    children: ReactNode;
    labelRef?: ForwardedRef<HTMLSpanElement>;
    onMouseEnter?: MouseEventHandler<HTMLSpanElement>;
}

const TruncatedText = (
    { lineClamp = 1, children, labelRef, onMouseEnter, ...props }: ITruncatedTooltipProps,
    ref: ForwardedRef<HTMLSpanElement>,
): ReactElement => {
    return (
        <StyledTruncatedText
            ref={ref}
            lineClamp={lineClamp}
            {...props}
        >
            <StyledTruncatedTextLabel
                ref={labelRef}
                lineClamp={lineClamp}
                onMouseEnter={onMouseEnter}
            >
                {children}
            </StyledTruncatedTextLabel>
        </StyledTruncatedText>
    );
};

export default forwardRef(TruncatedText);
